// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// API 호출 production/test 설정은
// src/service/API.js 에서 설정함

import Vue from 'vue'
import App from './App'
import router from './router'
import filter from './filters'
import store from './vuex/store' // vuex 저장소 추가
import axios from 'axios'
import api from './service'

import HeaderBar from "./components/HeaderBar"
import FooterBar from "./components/FooterBar"
import DefaultLayout from "./layouts/Default.vue"
import HomeLayout from "./layouts/Home.vue"
import AuthLayout from "./layouts/Auth.vue"
import ErrorLayout from "./layouts/Error.vue"
import Paginate from 'vuejs-paginate'
import VueCookie from 'vue-cookie'
import VueGtag from "vue-gtag"
import VueI18n from 'vue-i18n'
import langs from "@/locale/langs.json"
import appConfig from "@/config/app.config.json"
import Utc from "@/assets/js/utc.js"

Vue.prototype.$api = api
Vue.prototype.$http = axios
Vue.prototype.$cookie = VueCookie

Vue.component("header-bar", HeaderBar)
Vue.component("footer-bar", FooterBar)
Vue.component("default-layout", DefaultLayout)
Vue.component("home-layout", HomeLayout)
Vue.component("auth-layout", AuthLayout)
Vue.component("error-layout", ErrorLayout)
Vue.component("paginate", Paginate)

Vue.config.productionTip = false

Vue.use(VueGtag, {
	config: { id: "UA-164153012-1" },
	includes: [
		{ id: "AW-811465306" }
	]
}, router);

Vue.use(VueI18n)
const messages = langs
const i18n = new VueI18n({ locale: appConfig.locale, messages })

Vue.use(Utc)

/* eslint-disable no-new */
new Vue({
    router,
    render: h => h(App),
    store,
    computed: {
        count() {
            return store.state.count
        }
    },
    methods: {
        increment() {
            store.commit('increment')
        },
        decrement() {
            store.commit('decrement')
        }
    },
    i18n
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js